import { render, staticRenderFns } from "./ImportExportConfiguration.vue?vue&type=template&id=0578277d"
import script from "./ImportExportConfiguration.vue?vue&type=script&lang=js"
export * from "./ImportExportConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports